function MarketplaceOrderEditAssignmentStepForm() {
	return {
		fields: [
			'assignmentStep.requiredCarrier',
			'assignmentStep.requiredCarrierService',
			'assignmentStep.requiredWarehouse',
		],
		labels: {
			'assignmentStep.requiredCarrier': 'MARKETPLACEORDEREDITFORM.REQUIREDCARRIER',
			'assignmentStep.requiredCarrierService': 'MARKETPLACEORDEREDITFORM.REQUIREDCARRIERSERVICE',
			'assignmentStep.requiredWarehouse': 'MARKETPLACEORDEREDITFORM.REQUIREDWAREHOUSE',
		},
		rules: {},
	};
}

export default MarketplaceOrderEditAssignmentStepForm;



// WEBPACK FOOTER //
// ./src/modules/order/forms/wizard/MarketplaceOrderEditAssignmentStepForm.js